import React, { Suspense, useRef } from "react";
import { useEffect, useState } from "react";
import { Await, Link, defer, useLoaderData } from "react-router-dom";
import ApiServices from "../../service/ApiServices";
import { motion } from "framer-motion";

import { Header } from "../navigation/header/header";
import { Spinner } from "../template/spinner/spinner";
import { Categories } from "./categories/categories";
import { ProductCard } from "../template/product-card/product-card";
import { LocationModal } from "../template/modal/location-modal/location-modal";

import "./catalog.css";

const res = new ApiServices();

const Catalog = () => {

    const {categories, productsData, aboutData} = useLoaderData();

    const [about, setAbout] = useState({});
    const [loadedProducts, setProducts] = useState({});
    const [offset, setOffset] = useState([]);

    const showMoreProducts = (id, total) => {

        const currentOffset = offset.some(item => item.id === id) ? offset.find(item => item.id === id).offset : 10;
        
        res.showMoreProducts(id, currentOffset).then(data => {
            
            setProducts(prevProducts => {
                setOffset((prevOffset) => {
                   if (prevOffset.some(item => item.id === id)) {
                        return prevOffset.map(item => item.id ? {...item, offset: item.offset + 10} : item);
                   } else {
                        return [...prevOffset, {id: id, offset: 20}]
                   }
                })
                
                const loadedData = Object.values(data)[0];
                
                return {...prevProducts, [id]: (prevProducts[id] || []).concat(loadedData)};
               
            })
        })
    }

    useEffect(() => {
        aboutData.then(data => {
                setAbout(data);
            })
    })

    return (
        <>
            <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.5 } }}
            exit={{ opacity: 0 }}
            >
                <Header props={about}/>
                <div className="container-fluid">
                    <Categories data={categories}/>
                    <Suspense fallback={ <Spinner/> }>
                        <Await resolve={productsData}>
                        {(resolvedProducts) => {
                            const result = Object.entries(resolvedProducts).map(([id, item]) => {
                                const {category, products} = item;
                                return (
                                <React.Fragment key={id}>
                                    {/* назва категорії */}
                                    <span id={`category-${id}`}  className="category-title">{category}</span>
                                    {/* основний список продуктів */}
                                    {products.map(product => (
                                        
                                        <ProductCard key={product.id} props={product}/>
                                    ))}
                                    {/* тут рендеряться дозагружені продукти */}
                                    {loadedProducts[id] && loadedProducts[id].map((product, index) => (
                                        <ProductCard key={product.id} props={product}/>
                                    ))}
                                    {/* кнопка дозагрузки */}
                                    {(offset.some(item => item.id === id) && offset.find(item => item.id === id).offset > item.count) || (item.count < 10) ?
                                            null
                                        :
                                            <div className="row">
                                                <button className="btn btn-dark" onClick={() => showMoreProducts(id)}>Показати ще</button>
                                            </div>
                                           
                                    }
                                </React.Fragment>
                               
                                )
                            })
                            return result;
                        }}
                        </Await>
                    </Suspense>
                </div>
            </motion.div>
            <LocationModal props={about}/>
        </>
    )
}

const catalogLoader = async () => {
    return defer({
        categories: res.getCategorires(),
        productsData: res.getProductsByCategories(),
        aboutData: res.getAboutCompany(),
    })
}

export {Catalog, catalogLoader};